<template>
	<div>
		<v-list-item :style="{background: index % 2 == 0 ? '#efefef' : 'inherit'}">
			<v-list-item-action>
				<v-icon>{{ "tv" }}</v-icon>
			</v-list-item-action>
			<v-list-item-content>
				<v-list-item-title>{{ received.name }} | {{ received.terminal }}</v-list-item-title>
				<v-list-item-title v-if="received.feedback">{{ received.feedback.emotion == 'positive' ? '😊' : '🙁'}} {{received.feedback.email !== "" ? received.feedback.email : "-" }}</v-list-item-title>
			</v-list-item-content>
			<v-list-item-action>
				<v-row>
					<div class="d-flex align-center justify-end mr-2" v-if="received.includesFree">
						FREE
					</div>
					<v-btn v-if="isSurveyComplete" icon @click="dialog = true">
						<v-icon>{{ "question_answer" }}</v-icon>
					</v-btn>
					<div class="coin mr-4">
						<v-icon>{{ "attach_money" }}</v-icon>{{ received.amount }}
					</div>
					<v-btn icon @click="transferVideo(received.video, received.name)">
						<v-icon>{{ "play_arrow" }}</v-icon>
					</v-btn>
					<v-btn icon @click="removeVideo(received._id)">
						<v-icon>{{ "delete" }}</v-icon>
					</v-btn>
				</v-row>
			</v-list-item-action>
		</v-list-item>
		<SurveyResult v-if="dialog" :dialog="dialog" @close="dialog = false" :survey="received.feedback.survey.answers"/>
	</div>
</template>

<script>

import SurveyResult from "./SurveyResult.vue";

export default {
  name: "VideoCard",
	components: {
		SurveyResult
	},
  props: ["received", "index"],
	data: () => ({
		dialog: false
	}),
  methods: {
    transferVideo(video, name) {
      this.$emit("openVideo", { video, name });
    },
    removeVideo(id) {
      this.$http.delete("rest/videos/" + id).then(() => {
        this.$emit("removeVideo", id);
      });
    },
  },
	computed: {
		isSurveyComplete() {
			if (this.received.feedback) {
				if (this.received.feedback.survey) {
					if (this.received.feedback.survey.complete) {
						return true
					}
				}
			}
			return false
		}
	}
};
</script>

<style scoped>
	.coin {
		display: flex;
		justify-content: flex-start;
		width: 36px;
		align-items: center;
		line-height: 36px;
	}
</style>